module.exports = __webpack_public_path__ + "img/xitun-director.5b03b57e.png";